import PropTypes from 'prop-types';

import fetch from 'features/common/fetch';

import PKUrl from './PKUrl';

export const ISPPolicy = ({ policyNo, systemId, agreementType, children }) => {
	if (!policyNo || !systemId) return children;

	return (
		<PKUrl
			url={fetch.constants.urls.ispProvision}
			fetchArgs={{
				policyNo,
				systemId,
				...Object.assign({}, agreementType ? agreementType : null),
			}}
			doNotPreloadIascLink
		>
			{children}
		</PKUrl>
	);
};

ISPPolicy.propTypes = {
	agreementType: PropTypes.string,
	children: PropTypes.node,
	policyNo: PropTypes.number,
	systemId: PropTypes.number,
};

export default ISPPolicy;
